import { render } from "./popover.vue?vue&type=template&id=8d57cc1e"
import script from "./popover.js?vue&type=script&lang=js"
export * from "./popover.js?vue&type=script&lang=js"

import "./popover.vue?vue&type=style&index=0&id=8d57cc1e&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__